import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Space, Card, Select, Row, Col, Flex } from 'antd';
import StoreSettingService from "services/store_setting";
import ImagePicker from "components/pickers/image/ImagePicker"
import ThemeSetting from "components/pickers/theme-setting"
import { CloseOutlined, DeleteOutlined, EditOutlined, FullscreenOutlined } from '@ant-design/icons';
import { useForm, useWatch } from "antd/es/form/Form";
import { useApp } from 'contexts/app';

import ProductBlock from './ProductBlock';
import ImageBlock from './ImageBlock';
import MultiImageBlock from './MultiImageBlock';
import _ from "lodash"
const service = new StoreSettingService();



const BlocksEditor = ({ data, onChange, onDelete, showEdit, onShowEdit, onHideEdit }) => {
    const [form] = useForm();

    const [block, setBlock] = useState({})

    const { modal } = useApp();
    useEffect(() => {
        setBlock(data)
        console.log("set setFieldsValue", { ...data.setting })
        form.setFieldsValue({ ...data.setting })

    }, [data])

    const onFinish = async values => {

        if (onChange) {
            onChange({ ...data, setting: values })
        }
        // showLoading(true);
        // try {
        //     await service.saveHomePageSetting(values)
        //     await loadData();
        //     showNotify("Đã cập nhật")
        // } catch (error) {
        //     message.error("Không thể nhật")
        // }
        // showLoading(false);

    };
    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };


    const onValuesChange = (changedValues, allValues) => {

        if (onChange) {
            if (!_.isEqual(allValues, data.setting)) {
                console.log("block chnage", allValues, data.setting)
                onChange({ ...data, setting: allValues });

            }

        }
    }

    const onBtnDelete = async () => {
        modal.confirm({
            title: "Xoá?", content: "Bạn có chắc chắn muốn xoá", onOk: async () => {

                onDelete(data.id)

            }
        })
    }




    if (!showEdit) {
        return (


            <Card styles={{
                body: {

                    padding: 0
                }
            }}
                title={data.setting.title ?? "Block"} extra={<Space size="middle">
                    {/* <Button type='link' ><FullscreenOutlined /></Button> */}
                    <Button type='link' onClick={e => onShowEdit()}><EditOutlined /></Button>
                    <Button type='link' onClick={onBtnDelete}><DeleteOutlined /></Button>
                </Space>
                } size='small' >

            </Card>
        )
    }



    return (
        <Card title={data.setting.title ?? "Block"} extra={<Space size="middle">
            <Button type='link' onClick={e => onHideEdit(false)}><CloseOutlined /></Button>

        </Space>
        } size='small' >


            <Form
                form={form}
                name="basic"
                layout='vertical'
                style={{ width: "100%" }}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                onValuesChange={onValuesChange}

                autoComplete="off"
            >

                <Row gutter={8}>
                    <Col span={12}>

                        <Form.Item
                            label="Tiêu đề"
                            name="title"
                            rules={[{ required: true, message: 'Please input your website!' }]}
                        >
                            <Input></Input>
                        </Form.Item>
                    </Col>


                    <Col span={12}>


                        <Form.Item
                            label="Hiển thị tiêu đề"
                            name="show_title"
                            rules={[{ required: true, message: 'Please input your website!' }]}
                            valuePropName='checked'
                        >
                            <Checkbox></Checkbox>
                        </Form.Item>

                    </Col>




                </Row>
                {data.type == "product" &&
                    <ProductBlock form ={form}></ProductBlock>
                }
                {data.type == "image" &&
                    <ImageBlock></ImageBlock>
                }

                {data.type == "multi_image" &&
                    <MultiImageBlock></MultiImageBlock>
                }







            </Form>



        </Card>

    )
}
export default BlocksEditor;